import { Code, Faq, HelpSection, P, Screen, SeeAlso } from '../prose';

/**
 * よくある質問。
 *
 * 答えが記事にあるものは、要点を 1〜2 文で言ってからリンクで返す。
 * ここに説明を写すと、記事と食い違ったときにどちらが正か分からなくなる。
 */
export function FaqArticle() {
  return (
    <>
      <HelpSection heading="使い方">
        <Faq
          items={[
            {
              question: 'タスクやチケット単位で工数を記録できますか',
              answer: (
                <P>
                  {
                    'できません。管理する粒度は「誰が・どのプロジェクトに・どの月に・何時間」までです。現場に入力の手間を戻さないための設計上の判断です。'
                  }
                  <SeeAlso slug="overview">INOU の考え方</SeeAlso>
                  {' を参照してください。'}
                </P>
              ),
            },
            {
              question: '画面から毎日の工数を入力させたいのですが',
              answer: (
                <P>
                  {
                    '想定していません。記録の入口は MCP で、画面は確認と訂正のためにあります。画面から新しい記録を作れるのは本人の分だけです。'
                  }
                </P>
              ),
            },
            {
              question: '管理者が全員分の工数をまとめて入力できますか',
              answer: (
                <P>
                  {
                    'できません。新しい記録を作れるのは、経路を問わず本人だけです。管理者ができるのは、すでにある記録の訂正と削除です（'
                  }
                  <Screen to="/time-logs">工数明細</Screen>
                  {'）。'}
                </P>
              ),
            },
            {
              question: '作業カテゴリを自分で選びたいのですが',
              answer: (
                <P>
                  {
                    '記録するときには聞きません。AI が会話の内容から決めます。結果が違っていれば、あとから訂正できます。'
                  }
                  <SeeAlso slug="logging-time">工数の記録</SeeAlso>
                  {' を参照してください。'}
                </P>
              ),
            },
            {
              question: '他の人の工数や、全社の集計を AI から見られますか',
              answer: (
                <P>
                  {'見られません。MCP から扱えるのは自分の記録だけで、これはロールに関係しません。'}
                  <Code>admin</Code>
                  {' のトークンでも他の人の記録には届きません。'}
                </P>
              ),
            },
          ]}
        />
      </HelpSection>

      <HelpSection heading="数字の見え方">
        <Faq
          items={[
            {
              question: '先月のレポートの数字が変わったのですが',
              answer: (
                <P>
                  {
                    'プロジェクトの種別を付け替えると、直接／間接の比率は過去の月も変わります。集計のたびに種別を見て数えているためです。資産化の区分と請求可能かどうかは記録した時点で確定するので動きません。'
                  }
                  <SeeAlso slug="reading-reports">レポートの読み方</SeeAlso>
                  {' を参照してください。'}
                </P>
              ),
            },
            {
              question: '単価を全員分登録しないと金額が出ませんか',
              answer: (
                <P>
                  {
                    '組織の既定単価だけでも集計は動きます。人ごと・アサインごとの単価は、既定と違う場合にだけ入れてください。'
                  }
                </P>
              ),
            },
            {
              question: '資産化の対象を後から変えたら、過去の記録も変わりますか',
              answer: (
                <P>
                  {
                    '変わりません。記録済みの資産化区分はそのまま残ります。締めた月の数字が後から動かないようにするためです。'
                  }
                </P>
              ),
            },
          ]}
        />
      </HelpSection>

      <HelpSection heading="契約とアカウント">
        <Faq
          items={[
            {
              question: 'トライアルが終わるとデータは消えますか',
              answer: (
                <P>
                  {'消えません。参照はそのままできて、更新と MCP 接続だけが止まります。'}
                  <SeeAlso slug="plans-and-seats">プランとシート</SeeAlso>
                  {' を参照してください。'}
                </P>
              ),
            },
            {
              question: '招待したけれどまだ受諾されていない人も課金対象ですか',
              answer: (
                <P>
                  {
                    'シートは招待した時点で消費します。使わなくなった招待は取り消すか、その利用者を無効にすると枠が戻ります。'
                  }
                </P>
              ),
            },
            {
              question: '招待リンクの期限が切れました',
              answer: (
                <P>
                  {'管理者が '}
                  <Screen to="/members">メンバー</Screen>
                  {' から再発行できます。再発行できるのはまだパスワードを持っていない人だけです。'}
                </P>
              ),
            },
            {
              question: '同じメールアドレスで 2 つの組織に入れますか',
              answer: <P>{'入れません。組織ごとに別のメールアドレスを使ってください。'}</P>,
            },
            {
              question: '組織ごとのサブドメインはありますか',
              answer: (
                <P>
                  {
                    'ありません。どの組織も同じアドレスからログインします。どの組織かはログインした時点で決まります。'
                  }
                </P>
              ),
            },
          ]}
        />
      </HelpSection>
    </>
  );
}
